import React from 'react';
import { Button } from '../../components/ui/Button';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
interface AssessmentErrorModalProps {
  message: string;
  onClose: () => void;
}
export function AssessmentErrorModal({
  message,
  onClose
}: AssessmentErrorModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onClose);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" onClick={onClose} data-id="element-647" data-mp="xdhm35ru1fu9" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-648" data-mp="12batu38sahwn">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="assessment-error-title" className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8" data-id="element-649" data-mp="178jau0i74fwb">
          <div className="text-center" data-id="element-650" data-mp="ejm3utjfq5iv">
            <div className="text-6xl mb-4" data-id="element-651" data-mp="jjq91new7dts">📋</div>
            <h2 id="assessment-error-title" className="text-2xl font-bold text-slate-900 mb-3" data-id="element-652" data-mp="jif6fqx6oc49">
              Toets kan niet starten
            </h2>
            <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-653" data-mp="nz6ct57n3tg5">{message}</p>
            <Button onClick={onClose} variant="primary" size="lg" fullWidth data-id="element-654" data-mp="j6da0mvqev6p">
              Begrepen
            </Button>
          </div>
        </div>
      </div>
    </>;
}